
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "Erreur",
    notFound: "Page non trouvée",
    deleteAccountError: "Une erreur s'est produite lors de la suppression du compte. Veuillez réessayer.",
    loadStoryError: "Une erreur s'est produite lors du chargement de l'histoire. Veuillez réessayer.",
    loadCharactersError: "Une erreur s'est produite lors du chargement des personnages. Veuillez réessayer.",
    summaryError: "Une erreur s'est produite lors de la génération du résumé. Veuillez réessayer."
  }
};
